export default "__VITE_ASSET__BjH_MM3L__"